import type { QuestionAnalyticsChart } from '../../../../../../utils/buildQuestionAnalytics';
import { QuestionBars } from '../QuestionBars/QuestionBars';
import { QuestionOpenAnswers } from '../QuestionOpenAnswers/QuestionOpenAnswers';
import { QuestionPieChart } from '../QuestionPieChart/QuestionPieChart';

interface QuestionResultChartProps {
  chart: QuestionAnalyticsChart;
  questionText: string;
  /** Bars are shared by surveys and rating scales; only the colouring tells them apart. */
  isRating?: boolean;
  /** Full screen gives the chart a column of its own, so the pie is drawn flatter. */
  isExpanded?: boolean;
}

/**
 * The "overall result" of a question, whichever shape that takes. One place rather than
 * one per layout, so the side panel and full screen can never drift into showing a
 * different graphic for the same question.
 */
export const QuestionResultChart = ({
  chart,
  questionText,
  isRating = false,
  isExpanded = false,
}: QuestionResultChartProps) => {
  if (chart.kind === 'pie') {
    return (
      <QuestionPieChart
        correct={chart.correct}
        incorrect={chart.incorrect}
        unanswered={chart.unanswered}
        questionText={questionText}
        isExpanded={isExpanded}
      />
    );
  }

  if (chart.kind === 'bars') {
    return (
      <QuestionBars bars={chart.bars} questionText={questionText} isRating={isRating} />
    );
  }

  return <QuestionOpenAnswers answers={chart.answers} />;
};
